import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./CalculatorSection.module.css";
import Button from "../../Button/Button";
import logoShortLight from "../../../assets/images/logo-short-light.svg";
import logoShortDark from "../../../assets/images/logo-short-dark.svg";
import { ThemeContext } from "../../../context/ThemeContext";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useTranslation } from "../../../hooks/useTranslation";

const CalculatorSection: React.FC = () => {
  const navigate = useNavigate();
  const context = useContext(ThemeContext);
  const { t } = useTranslation();

  if (!context) {
    throw new Error('CalculatorSection must be used within a ThemeProvider');
  }

  const { theme } = context;
  const logo = theme === 'dark' ? logoShortDark : logoShortLight;

  return (
    <section className={styles.calculatorSection}>
      <div className={styles.content}>
        {/* Logo */}
        <img src={logo} alt="Calculator Logo" className={styles.logo} />

        <div className={styles.textContent}>
        {/* Title */}
        <h2 className={styles.title}>{t("calculator.title")}</h2>

        {/* Subtitle */}
        <p className={styles.subtitle}>
          {t("calculator.subtitle")}
        </p>

        </div>

        {/* Button */}
        <Button
          variant="primary"
          className={styles.button}
          rightIcon={<MdKeyboardArrowRight size={32} />}
          onClick={() => navigate('/calculator')}
        >
          {t("calculator.button")}
        </Button>
      </div>
    </section>
  );
};

export default CalculatorSection;
